import { FolderOutlined, MailOutlined, PersonOutlined } from '@mui/icons-material'
import { Box, Grid, MenuItem, Typography, useTheme } from '@mui/material'

import useSharedStyles from '../../../utils/shared.styles'
import HighlightText from '../../highlight-text'
import useStyles from '../index.styles'

interface IResultPeopleItemProps {
  name: string
  roleName: string
  email: string
  folderCount: number
  topLevelFolder: string
  searchValue: string
  onClick: () => void
}

const ResultPeopleItem = ({ name, roleName, email, folderCount, topLevelFolder, searchValue, onClick }: IResultPeopleItemProps) => {
  const classes = useStyles
  const sharedClasses = useSharedStyles
  const theme = useTheme()

  return (
    <MenuItem onClick={onClick} tabIndex={0} data-testid="search-result-item">
      <Grid
        container={true}
        wrap="nowrap"
        sx={{
          alignItems: 'flex-start',
        }}
      >
        <PersonOutlined sx={classes.searchItemIcon} />
        <Box sx={classes.resultItemTextContainer}>
          <Typography variant="body1" className="fs-exclude" sx={sharedClasses.overflowText}>
            <HighlightText text={name} query={searchValue} colorHighlight={true} />
            <Typography variant="caption" sx={classes.searchItemPrimaryTextCaption}>
              • <HighlightText text={roleName} query={searchValue} colorHighlight={true} />
            </Typography>
          </Typography>
          <Box sx={sharedClasses.overflowText}>
            {email && (
              <Typography variant="caption" className="fs-exclude" sx={sharedClasses.secondaryText}>
                <MailOutlined sx={{ ...classes.searchItemSecondaryTextIcon(theme), marginLeft: 0 }} />
                <HighlightText text={email} query={searchValue} colorHighlight={true} />
              </Typography>
            )}
            <Typography variant="caption" className="fs-exclude" sx={sharedClasses.secondaryText}>
              {email && ' • '}
              <FolderOutlined sx={{ ...classes.searchItemSecondaryTextIcon(theme), marginLeft: email ? 1 : 0 }} />
              {folderCount}
            </Typography>
            {topLevelFolder && (
              <Typography variant="caption" className="fs-exclude" sx={sharedClasses.secondaryText}>
                {' • '}
                {topLevelFolder}
              </Typography>
            )}
          </Box>
        </Box>
      </Grid>
    </MenuItem>
  )
}

export default ResultPeopleItem
